export const environment = {
	production: false,
	maintenance: false,
	phpServer: "/php"
};
